/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Unknownbuildlabel2Inputs */

const id_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build tidak diketahui`)
};

const ms_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binaan tidak diketahui`)
};

const da_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukendt build`)
};

const de_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekannter Build`)
};

const en_us2_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown build`)
};

const es_es2_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilación desconocida`)
};

const es_mx2_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilación desconocida`)
};

const fil_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi kilalang build`)
};

const fr_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilation inconnue`)
};

const it_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build sconosciuta`)
};

const hu_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ismeretlen build`)
};

const nl_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onbekende build`)
};

const no_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukjent build`)
};

const pl_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieznana kompilacja`)
};

const pt_br2_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build desconhecida`)
};

const pt_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilação desconhecida`)
};

const ro_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilare necunoscută`)
};

const fi_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuntematon koontiversio`)
};

const sv_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okänt bygge`)
};

const vi_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản dựng không xác định`)
};

const tr_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilinmeyen yapı`)
};

const cs_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neznámé sestavení`)
};

const bg_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Непозната компилация`)
};

const ru_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неизвестная сборка`)
};

const uk_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Невідома збірка`)
};

const ar_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بنية غير معروفة`)
};

const hi_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अज्ञात बिल्ड`)
};

const th_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บิลด์ที่ไม่รู้จัก`)
};

const ja_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不明なビルド`)
};

const zh_cn2_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知构建版本`)
};

const zh_hant1_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知建置版本`)
};

const ko_sandboxes_unknownbuildlabel2 = /** @type {(inputs: Sandboxes_Unknownbuildlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알 수 없는 빌드`)
};

/**
* | output |
* | --- |
* | "Unknown build" |
*
* @param {Sandboxes_Unknownbuildlabel2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_unknownbuildlabel2 = /** @type {((inputs?: Sandboxes_Unknownbuildlabel2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Unknownbuildlabel2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "ms") return ms_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "da") return da_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "de") return de_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "fil") return fil_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "fr") return fr_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "it") return it_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "hu") return hu_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "nl") return nl_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "no") return no_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "pl") return pl_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "pt") return pt_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "ro") return ro_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "fi") return fi_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "sv") return sv_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "vi") return vi_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "tr") return tr_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "cs") return cs_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "bg") return bg_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "ru") return ru_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "uk") return uk_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "ar") return ar_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "hi") return hi_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "th") return th_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "ja") return ja_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_unknownbuildlabel2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_unknownbuildlabel2(inputs)
	return ko_sandboxes_unknownbuildlabel2(inputs)
});
export { sandboxes_unknownbuildlabel2 as "sandboxes.unknownBuildLabel" }